// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1liTv","errorLogs":"styles_errorLogs__Dl3Me"};